"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var FirstSlide = function (_a) {
    var defaultCurrency = _a.defaultCurrency, firstDepPercents = _a.firstDepPercents, firstDepMaxBonus = _a.firstDepMaxBonus, firstDepFreespins = _a.firstDepFreespins;
    var t = (0, next_intl_1.useTranslations)('translation');
    var affBonusData = (0, swr_hooks_1.useAffiliateBonuses)().data;
    var affBonusRewards = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!affBonusData)
            return null;
        var percents = ((_c = (_b = (_a = affBonusData === null || affBonusData === void 0 ? void 0 : affBonusData[0]) === null || _a === void 0 ? void 0 : _a.rewards) === null || _b === void 0 ? void 0 : _b.find(function (r) { return r.type === 'RELATIVE'; })) === null || _c === void 0 ? void 0 : _c.relativePercent) || 0;
        var freespins = ((_f = (_e = (_d = affBonusData === null || affBonusData === void 0 ? void 0 : affBonusData[0]) === null || _d === void 0 ? void 0 : _d.rewards) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.type === 'FREE_ROUNDS'; })) === null || _f === void 0 ? void 0 : _f.freeRoundsCount) || 0;
        return { percents: percents, freespins: freespins };
    }, [affBonusData]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.contentWrapper },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, affBonusData && affBonusData.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                        affBonusRewards &&
                            Number(affBonusRewards.percents) !== 0 &&
                            affBonusRewards.percents + '%',
                        affBonusRewards &&
                            Number(affBonusRewards.percents) === 0 &&
                            affBonusRewards.freespins !== 0 &&
                            affBonusRewards.freespins + t('fs')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('firstDepositBonus')),
                    react_1.default.createElement("div", null, !!(affBonusRewards === null || affBonusRewards === void 0 ? void 0 : affBonusRewards.freespins) &&
                        (!!(affBonusRewards === null || affBonusRewards === void 0 ? void 0 : affBonusRewards.percents) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.upTo },
                            "+ ", affBonusRewards === null || affBonusRewards === void 0 ? void 0 :
                            affBonusRewards.freespins,
                            " ",
                            t('freespins'))) : null)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                        firstDepPercents,
                        "%"),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('firstDepositBonus')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.upTo, dangerouslySetInnerHTML: {
                            __html: t('upToFresspinsBR', {
                                maxBonus: "".concat(firstDepMaxBonus, " ").concat(defaultCurrency),
                                freespins: firstDepFreespins,
                            }),
                        } })))),
                react_1.default.createElement(image_1.default, { className: styles_module_scss_1.default.girl, width: 288, height: 371, src: "/img/signup/slider/girl.png", alt: "girl" })))));
};
exports.default = FirstSlide;
